export default __webpack_public_path__ + "static/media/add-user-icon.4b36a1ef.svg";